import React from "react";
import {HtmlDisplay} from "../Display";
import {helpTextSuffix} from "./inputConstants";

interface HelpTextProps {
	helpText?: string;
	responseFeedback?: string;
	isCentered?: boolean;
	name: string;
}

export const HelpText: React.FC<HelpTextProps> = ({
	                         helpText,
	                         responseFeedback,
	                         isCentered,
	                         name,
						}: HelpTextProps) => {
	const responseFeedbackClass = responseFeedback ? `help-text--feedback` : ``;
	return <HtmlDisplay
		className={`help-text ${responseFeedbackClass} ${isCentered ? "text-center" : ""}`}
		isUpdatedLive
		html={responseFeedback || helpText} name={`${name}${helpTextSuffix}`}
	/>;
};
